import { useContext } from 'react';
import { AnalyticsContext } from './context.js';

var useAnalytics = function () {
    var context = useContext(AnalyticsContext);
    if (!context) {
        throw new Error('should be used inside AnalyticsProvider');
    }
    return context;
};

export { useAnalytics };
//# sourceMappingURL=hooks.js.map
